<script>
    import constants from '@/constants';
    import { changeData } from '@/scripts/tools.js';

    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            filterType() {return constants.FILTER_TYPE},
            assetTypes() {return this.$store.getters.ASSET_TYPES},
            addData() {return this.$store.getters.FILTER_DATA_ADD},
            filterParent() {return this.$store.getters.FILTER_PARENT_FILTER(this.addData.asset_type_id, true)}
        },
        async mounted() {
            await this.defaultValue();
        },
        methods: {
            async defaultValue() {
                if (this.addData.asset_type_id == null || this.addData.asset_type_id < 1) {
                    this.$store.commit('FILTER_DATA_ADD_UPDATE', {
                        fieldName: 'asset_type_id',
                        fieldValue: this.$store.getters.ASSET_TYPE_IMAGES,
                    })
                }
            },
            async updateData(event, fieldName, isCheckBox = false) {
                this.errorText = await changeData(
                    event, fieldName, 'FILTER_DATA_ADD_UPDATE', 'CHECK_FILTER_ADD', isCheckBox
                );
            },
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input 
            :value="addData['name']"
            @change="updateData($event, 'name')"
            type="text"
            class="right_input mt_5 mb_10"
        >
        <label>Description:</label>
        <input 
            :value="addData['description']"
            @change="updateData($event, 'description')"
            type="text"
            class="right_input mt_5 mb_10"
        >

        <label>Asset Type:</label>
        <select
            :value="addData['asset_type_id']"
            @change="updateData($event, 'asset_type_id')"
            class="right_input mt_5 mb_10"
        >
            <option
                v-for="(assetTypeValue, assetTypeIndex) in assetTypes" :key="assetTypeIndex"
                :value="assetTypeValue['id']"
            >
                {{ assetTypeValue['name'] }}
            </option>
        </select>
        <label>Filter Type:</label>
        <select
            :value="addData['filter_type']"
            @change="updateData($event, 'filter_type')"
            class="right_input mt_5 mb_10"
        >
            <option
                v-for="(filterTypeValue, filterTypeIndex) in filterType" :key="filterTypeIndex"
                :value="filterTypeValue['id']"
            >
                {{ filterTypeValue['name'] }}
            </option>
        </select>

        <label
            class="mb_5"
        >
            <input 
                type="checkbox"
                :checked="addData['is_required']"
                @change="updateData($event, 'is_required', true)"
            >
            Required
        </label>
        <label
            class="mb_5"
        >
            <input 
                type="checkbox"
                :checked="addData['is_multiple']"
                @change="updateData($event, 'is_multiple', true)"
            >
            Multiple
        </label>
        <label
            class="mb_10"
        >
            <input 
                type="checkbox"
                :checked="addData['have_sub_filter']"
                @change="updateData($event, 'have_sub_filter', true)"
            >
            Have Sub Filter
        </label>

        <label>Parent Filter:</label>
        <select
            :value="addData['parent_id']"
            @change="updateData($event, 'parent_id')"
            class="right_input mt_5"
        >
            <option value="None">
                None
            </option>
            <option
                v-for="(filterParentValue, filterParentIndex) in filterParent" :key="filterParentIndex"
                :value="filterParentValue['id']"
            >
                {{ filterParentValue['name'] }}
            </option>
        </select>

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>